import { useTranslation } from "react-i18next"
import "./styles.css"
import Filters from "../ProjectLibrary/Filters"
import { useEffect, useState } from "react"
import { Table } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { getMinMaxCostsAction, getProjectsAnalogsAction, getSummaryCostsAction } from "../ProjectLibrary/store/actions"
import { Link } from "react-router-dom"
import CustomPagination from "../../components/CustomPagination"
import CustomButton from "../../components/CustomButton"
import CompareForm1 from "../ProjectLibrary/CompareForm/CompareForm1"
import CompareForm2 from "../ProjectLibrary/CompareForm/CompareForm2"

const Reporting = () => {
    const [filters, setFilters] = useState({
        floors: [null, null],
        appartments: [null, null],
        commonSquare: [null, null],
    })
    const [page, setPage] = useState(1)
    const [selectedRows, setSelectedRows] = useState([])
    const [viewBlock, setViewBlock] = useState('default')

    const pageSize = 15
    const { t } = useTranslation(['project'])
    const dispatch = useDispatch()
    const { projectAnalogsList, isLoading } = useSelector(state => state.projectReducer)

    useEffect(() => {
        onPaginationChange(1)
    }, [filters])

    const onPaginationChange = (values) => {
        setPage(values)
        dispatch(getProjectsAnalogsAction({
            page: values,
            pageSize,
            ...filters
        }))
    }

    return <section className="reporting_wrapper">
        <div className="projects__header">
            <Link to="/">
                <div className="project__link__back">
                    <img alt="" src="/Arrow.svg" />
                    {t("common:back")}
                </div>
            </Link>
            <h2>{t("project:reportingTitle")}</h2>
        </div>
        {/* <header>{t("project:reportingTitle")}</header> */}
        <main className="reporting_body">
            <Filters
                filters={filters}
                setFilters={setFilters}
            ></Filters>
            {viewBlock === 'default' ? <div className="table_wrapper">
                {selectedRows?.length > 1 ?
                    <div className="reporting_compare_buttons">
                        <CustomButton
                            onClick={() => {
                                dispatch(getSummaryCostsAction({ analogObjectIds: selectedRows.map(el => el.analogObjectId) }))
                                setViewBlock("compareForm1")
                            }}
                        >
                            Сравнить по форме 1
                        </CustomButton>
                        <CustomButton
                            onClick={() => {
                                dispatch(getMinMaxCostsAction({ analogObjectIds: selectedRows.map(el => el.analogObjectId) }))
                                setViewBlock("compareForm2")
                            }}
                        >
                            Сравнить по форме 2
                        </CustomButton>
                        <CustomButton
                            type="grey"
                            onClick={() => setSelectedRows([])}
                        >
                            Сбросить
                        </CustomButton>
                    </div>
                    : null}
                <Table
                    dataSource={projectAnalogsList?.items?.map(el => {

                        return { key: el.analogObjectId, ...el }
                    })}
                    bordered
                    pagination={false}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRows.map(r => r?.analogObjectId),
                        onSelect: (record, selected) => {
                            let selectedKeys
                            if (selected) {
                                selectedKeys = [...selectedRows]
                                selectedKeys.push(record)
                            } else {
                                selectedKeys = selectedRows.filter(n => n.key !== record.key)
                            }
                            setSelectedRows(selectedKeys)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            let keys = selectedRows
                            setSelectedRows(keys)
                        },
                    }}
                    loading={isLoading}
                >
                    <Table.Column
                        dataIndex="name"
                        title="Название"
                    />
                    <Table.Column
                        dataIndex="code"
                        title="Код"
                    />
                    <Table.Column
                        dataIndex="reRegionName"
                        title="Регион"
                    />
                    <Table.Column
                        dataIndex="area"
                        title="Общая площадь"
                    />
                </Table>
                {projectAnalogsList?.count > pageSize ? <div className="reporting_paginations">
                    <CustomPagination
                        current={page}
                        total={projectAnalogsList.count}
                        showSizeChanger={false}
                        pageSize={pageSize}
                        onChange={onPaginationChange}
                    />
                </div>
                    : null}
            </div> : null}
            {viewBlock === "compareForm1" ?
                <CompareForm1
                    setViewBlock={setViewBlock}
                />
                : null}
            {viewBlock === "compareForm2" ?
                <CompareForm2
                    setViewBlock={setViewBlock}
                />
                : null}

        </main>
    </section>
}

export default Reporting